<template>
  <div id="site__container">
    <h2>Error, page not found!</h2>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
h2 {
  color: white;
  font-size: 30px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// notfound.vue?6562bc04